import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { hasPermission } from '@tiltgroup/web-components';
import { Permission } from '@shared/interfaces/permission';
import { FREIGHT_MATCHING_ENABLED } from '@shared/feature-flags';

export enum ToolsRoutes {
  FUEL_PRICES = 'fuel-prices',
  COMMODITY_SEARCH = 'nmfc-catalogue',
  ALERTS = 'alerts',
  ALERT_CENTER = 'alert-center',
  TASKS = 'tasks',
  DOCUMENT_REVIEW = 'document-review',
  LANE_PRICING = 'lane-pricing',
  FREIGHT_MATCHING = 'freight-matching',
}

export const TOOLS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./tools.component').then((m) => m.ToolsComponent),
    children: [
      {
        path: ToolsRoutes.FUEL_PRICES,
        loadChildren: () =>
          import('./pages/fuel-prices/fuel-prices-routing').then(
            (m) => m.FUEL_PRICES_ROUTES
          ),
      },
      {
        path: `${ToolsRoutes.COMMODITY_SEARCH}`,
        loadChildren: () =>
          import('./pages/commodity/commodity-routing').then(
            (m) => m.COMMODITY_ROUTES
          ),
        canActivate: [autoLoginPartialRoutesGuard],
      },
      {
        path: `${ToolsRoutes.LANE_PRICING}`,
        loadChildren: () =>
          import('./pages/lane-pricing/lane-pricing-routing').then(
            (m) => m.LANE_PRICING_ROUTES
          ),
        canActivate: [autoLoginPartialRoutesGuard],
      },
      {
        path: ToolsRoutes.FREIGHT_MATCHING,
        loadChildren: () =>
          import('./pages/freight-matching/freight-matching-routing').then(
            (m) => m.FREIGHT_MATCHING_ROUTES
          ),
        // Unmatched, a direct link falls through to the dashboard.
        canMatch: [() => inject(FREIGHT_MATCHING_ENABLED)],
        canActivate: [
          autoLoginPartialRoutesGuard,
          () => hasPermission(Permission.VIEW_SHIPMENT_FREIGHT_MATCHING),
        ],
      },
      {
        path: `${ToolsRoutes.TASKS}`,
        loadComponent: () =>
          import('./pages/tasks/tasks.component').then((m) => m.TasksComponent),
        canActivate: [autoLoginPartialRoutesGuard],
      },
      {
        path: `${ToolsRoutes.ALERT_CENTER}`,
        loadChildren: () =>
          import('./pages/alert-center/alert-center-routing').then(
            (m) => m.ALERT_CENTER_ROUTES
          ),
        canActivate: [autoLoginPartialRoutesGuard],
      },
      {
        path: ToolsRoutes.DOCUMENT_REVIEW,
        loadChildren: () =>
          import('./pages/document-review/document-review-routing').then(
            (m) => m.DOCUMENT_REVIEW_ROUTES
          ),
        canActivate: [
          autoLoginPartialRoutesGuard,
          () => hasPermission(Permission.VIEW_SHIPMENT_DETECTION_DOCUMENT),
        ],
      },
    ],
  },
];
